import Plyr from 'plyr';

const player = new Plyr('.video-player video', {
    debug: false,
    controls: ['play', 'progress', 'mute', 'volume', 'fullscreen']
});


/*const audioPlayer = new Plyr('audio', {
    debug: false,
    controls: ['current-time', 'progress', 'duration'],
});

$(function () {
    $('.custom-range').each((id, el) => {
        $(el).css('--value', $(el).val().toString() + '%');
    });
    $(document).on('input', '.custom-range', (e) => {
        $(e.currentTarget).css('--value', $(e.currentTarget).val().toString() + '%');
    });
    $(document).on('input', '.audio-sound-range', (e) => {
        audioPlayer.volume = parseFloat($(e.currentTarget).val().toString()) / 100;
    });
});


$(function () {
    $(document).on('click', '.podcasts-play-btn', (e) => {
        if (audioPlayer.paused) {
            audioPlayer.play();
            $(e.currentTarget).addClass('audio-played');
        } else {
            audioPlayer.pause();
            $(e.currentTarget).removeClass('audio-played');
        }
    });
});*/
